import * as types from "../../types"

const initialState = {
  id: null,
  login: false,
  loading: false,
  loadingCount: 0, // 追蹤同時進行的 API 請求數量
  county: "",
  user_id: "",
  user_ip: "",
  user_name: "",
  role_name: "",
  role_id: "",
  role_type: "",
  access_token: "",
  timeout: "",
  currentMenu: "1",
  currentStep: "1",
  office_section: {}
}

export default function authReducer(state = initialState, { type, payload }) {
  switch (type) {
    case types.LOGIN: {
      return {
        ...state,
        login: true,
        ...payload
      }
    }
    case types.LOGOUT: {
      return { ...initialState }
    }
    case types.OPEN_LOADING: {
      const newCount = state.loadingCount + 1
      return {
        ...state,
        loading: true,
        loadingCount: newCount
      }
    }
    case types.CLOSE_LOADING: {
      const newCount = Math.max(0, state.loadingCount - 1)
      return {
        ...state,
        loading: newCount > 0, // 只有當計數器為 0 時才關閉 loading
        loadingCount: newCount
      }
    }
    case types.OPEN_TIMEOUT_DIALOG: {
      return {
        ...state,
        timeout: true
      }
    }
    case types.CLOSE_TIMEOUT_DIALOG: {
      return {
        ...state,
        timeout: false
      }
    }
    case types.SAVE_MENU_STATUS: {
      return {
        ...state,
        currentMenu: payload.currentMenu,
        currentStep: payload.currentStep
      }
    }
    default:
      return state
  }
}
